<ng-container *ngIf="!loading">
  <div class="text-white h-100">
    <div class="py-5 px-3 p-lg-5 h-100 text-center text-xl-start">

      <div class="overflow-xl-auto h-100 d-flex flex-column align-items-start ">

       
    <span class="fs-5">
      <img src="{{logoPath}}" alt="{{title}}" title="{{title}}" class="logo"/>
    </span>
        

        <div class="sidebar-content w-100 mt-5 mt-xl-auto">

          <h1 class="sidebar-title text-white m-0 pt-0 pb-3 fw-bold">
            {{title}}
          </h1>
          <div class="sidebar-claim lead pb-4 d-none d-lg-block" [innerHTML]="projectClaim">
          </div>
          <div class="sidebar-icons d-inline-block mx-auto">
            <div class="pb-2 pb-lg-3 align-items-center d-flex justify-content-start">
              <div class="fs-4 pe-3">
                <i class="fa-regular fa-check-double"></i>
              </div>
              <div>
                {{projectLine1}}
              </div>
            </div>
            <div class="pb-2 pb-lg-3 align-items-center d-flex justify-content-start">
              <div class="fs-4 pe-3">
                <i class="fa-regular fa-check-double"></i>
              </div>
              <div>
                {{projectLine2}}
              </div>
            </div>
          </div>
          <div class="sidebar-trustpilot pt-3 pt-lg-5">
            <app-trustpilot
              [trustpilotTheme]="'dark'"
              [trustpilotType]="'mini'"
              [displayClass]="'d-none d-xl-block'"
            >
            </app-trustpilot>
            <app-trustpilot
              [trustpilotTheme]="'dark'"
              [trustpilotType]="'micro'"
              [displayClass]="'d-xl-none'"
            >
            </app-trustpilot>
          </div>

          <div class="d-xl-none mt-4 mt-lg-5">
            <a (click)="scrollToMainContent()" style="cursor: pointer;">
              <img src="./assets/images/mobile_scroll_down.svg" title="Zum Formular scrollen">
            </a>
          </div>

        </div>
      </div>
    </div>

    <div class="sidebar-bg-image position-absolute left-0 top-50 d-none d-xl-block">
      <!-- TODO @Sascha: Background Image bitte neu positionieren -->
      <img src="./assets/images/advofin-logo-background.png" class="project-background" title="Background {{title}}">
      <!-- TODO @Roland: Background Image URL -->
    </div>

  </div>
</ng-container>
